namespace GeniuzPOS.Administration {
    export class PsConfigColumns {
        static columnsKey = 'Administration.PsConfig';
    }
}
